import { combineReducers } from '@reduxjs/toolkit'
import appInitReducer from "app/reducers/appInitSlice";
import apiKeysReducer from "app/reducers/apiKeySlice";
import loginUserReducer from "app/reducers/loginUserSlice";
import venueReducer from "app/reducers/venueSlice";
import dashboardReducer from "app/reducers/dashboardSlice";

const rootReducer = combineReducers({
    apiKeysReducer,
    appInitReducer,
    loginUserReducer,
    venueReducer,
    dashboardReducer
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer